// extracted by mini-css-extract-plugin
export default {"middleContainer":"ImADLu0yzCY4bxdppAqF","icon":"WoSFLZ_ft485f4fI9u8M"};